// extracted by mini-css-extract-plugin
export default {"page":"CQkmeKCb_LIPjRojSL94","empty":"P4tDKlq3izx69cJypHAK","loading":"dAMrsz6rA0JR9kdipB0m"};